import { apiService, ApiResponse } from './api';
import { BodyAssessment } from '../types/BodyAssessment';

class BodyAssessmentService {
  async getHistory(memberId: number): Promise<ApiResponse<BodyAssessment[]>> {
    return apiService.get<BodyAssessment[]>(`/api/members/${memberId}/assessments`);
  }

  async getLatest(memberId: number): Promise<ApiResponse<BodyAssessment | null>> {
    return apiService.get<BodyAssessment | null>(`/api/members/${memberId}/assessments/latest`);
  }

  async create(memberId: number, data: Partial<BodyAssessment>): Promise<ApiResponse<BodyAssessment>> {
    return apiService.post<BodyAssessment>(`/api/members/${memberId}/assessments`, data);
  }
}

export const bodyAssessmentService = new BodyAssessmentService(); 